import React from 'react';
import { Link } from 'react-router-dom';
import { useFetchSubscriptions } from '../hooks/DataFetching/useFetchSubscriptions';

export default function MyColonies() {
  const { subscriptions, loading } = useFetchSubscriptions();

  if (loading) return <p className="text-sm italic text-muted">Loading your communities...</p>;

  if (!subscriptions || subscriptions.length === 0)
    return <p className="text-sm italic text-muted">You’re not a member of any communities yet.</p>;

  return (
    <ul className="divide-y divide-border max-h-64 overflow-y-auto">
      {subscriptions.map((subscription) => (
        <li key={subscription.id} className="py-2 flex justify-between items-center">
          <Link to={`/group-members/${subscription.groupId}`} className="text-yellow-400 hover:underline">
            {subscription.groupName}
          </Link>
        </li>
      ))}
    </ul>
  );
}
